document.addEventListener('DOMContentLoaded', function(e) {
    let galleries = document.querySelectorAll('section.gallery');
    if (galleries) {
        galleries.forEach(gallery => {
            let galleryItems = gallery.querySelectorAll('.grid-parent img');
            let lightbox = gallery.querySelector('.lightbox');
            let close = lightbox.querySelector('button.close');
            let prev = lightbox.querySelector('button.prev');
            let next = lightbox.querySelector('button.next');

            galleryItems.forEach(item => {
                item.addEventListener('click', () => {
                    lightbox.classList.add('open');
                    lightbox.dataset.index = item.dataset.index;
                })
            })

            close.addEventListener('click', () => {
                lightbox.classList.remove('open')
            })

            prev.addEventListener('click', () => {
                let index = parseInt(lightbox.dataset.index);
                if (index > 1) {
                    index--;
                    lightbox.dataset.index = index;
                } else {
                    index = galleryItems.length;
                    lightbox.dataset.index = index;
                }
            })

            next.addEventListener('click', () => {
                let index = parseInt(lightbox.dataset.index);
                if (index < galleryItems.length) {
                    index++;
                    lightbox.dataset.index = index;
                } else {
                    index = 1;
                    lightbox.dataset.index = index;
                }
            })
        })
    }
})